<section *ngIf="totalPageCount > 1 || !totalItemsCount" class="table-pagination flex-center">
    <ng-container *ngFor="let page of pagesToShow; trackBy: trackByValue">
        <button
            *ngIf="page === stepDirectionEnum.PREVIOUS"
            mat-button
            class="table-pagination__button table-pagination__button--directed"
            aria-label="Show previous table page"
            (click)="onPageChange(currentPageNumber - 1)"
        >
            <mat-icon>chevron_left</mat-icon>
        </button>

        <button
            *ngIf="page | isNumber"
            mat-button
            class="table-pagination__button"
            [attr.aria-label]="'Go to the table page ' + page"
            [disabled]="page === currentPageNumber"
            [ngClass]="{ 'table-pagination__button--active': page === currentPageNumber }"
            (click)="onPageChange(+page)"
        >
            {{ page }}
        </button>

        <button
            *ngIf="page === stepDirectionEnum.NEXT"
            mat-button
            class="table-pagination__button table-pagination__button--directed"
            aria-label="Show next table page"
            (click)="onPageChange(currentPageNumber + 1)"
        >
            <mat-icon>chevron_right</mat-icon>
        </button>
    </ng-container>
</section>
